import { render, staticRenderFns } from "./MaterialRecord.vue?vue&type=template&id=605588da"
import script from "./MaterialRecord.vue?vue&type=script&lang=js"
export * from "./MaterialRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports